<template>
  <div class="grossingTabPhoto">
    <b-row class="d-flex align-items-center mb-2 mt-1">
      <b-col>
        <span class="ap-title ap-title__main">{{ $t('grossing.content.multimedia') }}</span>
      </b-col>
      <b-col
        cols="auto"
        class="d-flex justify-content-end"
      >
        <div>
          <!--            TODO: uncomment this when grid is implemented-->
          <!--          <b-button class="btn__icon btn__icon--primary px-2" @click="viewToggle=!viewToggle">-->
          <!--            <i v-if="viewToggle" class="fal fa-table" v-tooltip="$t('diagnosis.btns.gridView')" aria-hidden="true"></i>-->
          <!--            <i v-if="!viewToggle" class="far fa-images" v-tooltip="$t('diagnosis.btns.thumbView')" aria-hidden="true"></i>-->
          <!--          </b-button>-->
          <template v-if="$_canAttachDocumentToSample()">
            <b-button
              v-tooltip="$t('grossing.modal.capture')"
              qa="sample-processing-tab-images-capture-button"
              class="btn__icon btn__icon--primary px-2"
              :disabled="isCaseValidated || !$_canBeDocumentAttachedToSample(sample)"
              @click="showPhotoModal"
            >
              <i
                class="far fa-camera"
                aria-hidden="true"
              />
            </b-button>
            <b-button
              v-tooltip="$t('grossing.content.uploadMedia')"
              qa="sample-processing-tab-images-upload-button"
              class="btn__icon btn__icon--primary  px-2"
              :disabled="isCaseValidated"
              @click="showSampleAttachmentModal"
            >
              <i
                class="far fa-folder-open"
                aria-hidden="true"
              />
            </b-button>
            <b-button
              v-tooltip="$t('grossing.content.deleteMedia')"
              qa="sample-processing-tab-images-delete-button"
              class="btn__icon btn__icon--primary  pl-2 pr-0"
              :disabled="isCaseValidated || !attachmentsChecked"
              @click="deleteAttachmentConfirmation"
            >
              <i
                class="far fa-trash-alt"
                aria-hidden="true"
              />
            </b-button>
          </template>
        </div>
      </b-col>
    </b-row>
    <!--Grossing Tab Request Grid-->
    <div v-if="!viewToggle">
      <vt-grid
        qa="sample-processing-tab-images-grid"
        class="registry-photo-grid"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        component-code="uicomponent.grossing.samplegrid"
        :use-detail-custom-config="true"
      />
    </div>
    <div
      v-if="viewToggle"
      class="thumbs"
    >
      <b-row
        v-if="!macroEditedAttachments.length && !macroImageAttachments.length"
        class="h-50 d-flex justify-content-center align-items-center mt-5"
      >
        <b-col
          md="9"
          lg="7"
          xl="6"
          class="text-center mt-3"
        >
          <div
            style="opacity: .5"
            class="m-3"
          >
            <i
              class="fal fa-image fa-3x"
              aria-hidden="true"
            />
          </div>
          <div>
            <span class="is-italic">{{ $t('global.description.pictureEmptyTitle') }}</span>
          </div>
          <div class="mt-3">
            <p>{{ $t('global.description.pictureEmptyGrossingSubtitle') }}</p>
          </div>
        </b-col>
      </b-row>
      <b-row
        v-if="macroEditedAttachments.length"
        class="px-3 pb-3"
      >
        <b-col>
          <b-row>
            <b-col
              cols="auto"
              class="pr-0"
            >
              <b-button
                v-b-toggle.collapse-edit
                qa="sample-processing-tab-images-collapse-button"
                class="photo-collapse m-1 main"
                @click="chevronEdit = !chevronEdit"
              >
                <i
                  v-if="chevronEdit"
                  class="fal fa-chevron-up mr-2"
                  aria-hidden="true"
                />
                <i
                  v-else
                  class="fal fa-chevron-down mr-2"
                  aria-hidden="true"
                />
                {{ $t('grossing.content.edited') }} ({{ macroEditedAttachments.length }})
              </b-button>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-collapse
                id="collapse-edit"
                visible
              >
                <b-row>
                  <!-- TODO: Oculto del código de momento los dos thumbnails demo -->
                  <!--<vt-thumbnail :sample-id="-1" @attachmentChecked="handleMockAttachmentChecked" @attachmentSelected="openViewer({ imageType: 'DEMO_STATIC' })" />
                  <vt-thumbnail :subportion-id="-1" @attachmentChecked="handleMockAttachmentChecked" @attachmentSelected="openViewer({ imageType: 'DEMO_WMTS' })" />-->
                  <vt-thumbnail
                    v-for="(attachment) in macroEditedAttachments"
                    id="grossingEditedThumbnail"
                    :key="attachment.attachmentId"
                    ref="grossingEditedThumbnail"
                    :laboratory-id="laboratoryId"
                    :case-id="caseId"
                    :sample-id="sample.id"
                    :attachment="attachment"
                    :sample-label="sample.label"
                    @attachmentSelected="openViewer"
                  />
                </b-row>
              </b-collapse>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row
        v-if="macroImageAttachments.length"
      >
        <b-col>
          <b-row>
            <b-col
              cols="auto"
              class="pr-0"
            >
              <b-button
                v-b-toggle.collapse-orig
                class="photo-collapse m-1 main"
                @click="chevronOrig = !chevronOrig"
              >
                <i
                  v-if="chevronOrig"
                  class="fal fa-chevron-up mr-2"
                  aria-hidden="true"
                />
                <i
                  v-else
                  class="fal fa-chevron-down mr-2"
                  aria-hidden="true"
                />
                {{ $t('grossing.content.originals') }} ({{ macroImageAttachments.length }})
              </b-button>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-collapse
                id="collapse-orig"
                visible
              >
                <b-row qa="sample-processing-tab-photo-container">
                  <vt-thumbnail
                    v-for="(attachment) in macroImageAttachments"
                    id="grossingThumbnail"
                    :key="attachment.attachmentId"
                    ref="grossingThumbnail"
                    :laboratory-id="laboratoryId"
                    :case-id="caseId"
                    :sample-id="sample.id"
                    :sample-label="sample.label"
                    :attachment="attachment"
                    @attachmentSelected="openViewer"
                  />
                </b-row>
              </b-collapse>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row v-if="macroVideoAttachments.length">
            <b-col
              cols="auto"
              class="pr-0"
            >
              <b-button
                v-b-toggle.collapse-video
                class="photo-collapse m-1 main"
                @click="chevronVideo = !chevronVideo"
              >
                <i
                  v-if="chevronVideo"
                  class="fal fa-chevron-up mr-2"
                  aria-hidden="true"
                />
                <i
                  v-else
                  class="fal fa-chevron-down mr-2"
                  aria-hidden="true"
                />
                {{ $t('grossing.content.videos') }} ({{ macroVideoAttachments.length }})
              </b-button>
            </b-col>
            <b-col>
              <hr>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-collapse
                id="collapse-video"
                visible
              >
                <b-row>
                  <vt-thumbnail
                    v-for="(attachment) in macroVideoAttachments"
                    id="grossingVideosThumbnail"
                    :key="attachment.attachmentId"
                    ref="grossingVideosThumbnail"
                    :laboratory-id="laboratoryId"
                    :case-id="caseId"
                    :sample-id="sample.id"
                    :attachment="attachment"
                  />
                </b-row>
              </b-collapse>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <modal-wrapper ref="addFileModalWrapper">
      <add-file-modal
        id="addFileModal"
        ref="addFileModal"
        :attachment-entity-type="ATTACHMENT_ENTITY_TYPE"
        :entities-id-array="entitiesIdArray"
        @attachmentsAdded="onAttachmentsAdded($event)"
      />
    </modal-wrapper>
    <modal-confirmation
      id="grossingTabPhotoConfirmationModal"
      ref="confirmationModal"
    />
    <modal-wrapper ref="modalPhotoWrapper">
      <modal-photo
        id="modal-photo"
        ref="modalPhoto"
        :attachment-entity-type="ATTACHMENT_ENTITY_TYPE"
        :entities-id-array="entitiesIdArray"
        :sample-label="sample.label"
        @attachmentsAdded="onAttachmentsAdded($event)"
      />
    </modal-wrapper>
  </div>
</template>

<script>
import VtGrid from '@/components/VtGrid/VtGrid'
import VtThumbnail from '@/components/common/VtThumbnail'
import sampleAttachmentService from '@/api/resources/attachment/sampleAttachmentService'
import AddFileModal from '@/components/AddFileModal'
import ModalConfirmation from '@/components/modals/ModalConfirmation'
import ModalPhoto from '@/modules/sampleProcessingModule/views/form/modals/ModalPhoto'
import { ATTACHMENT_ENTITY_TYPE } from '@/api/resources/attachment/attachmentResource'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'
import { viewerService } from '@/modules/viewerModule/services/viewer.service'
import { ViewerType, BROADCAST_ATTACHMENT_UPDATED_CHANNEL } from '@/modules/viewerModule/ViewerModule.models'
import { ATTACHMENT_MIME_TYPES } from '@/api/resources/attachment/attachmentTypeService'

export default {
    name: 'SampleProcessingTabPhoto',
    components: {
        VtGrid,
        VtThumbnail,
        AddFileModal,
        ModalConfirmation,
        ModalPhoto
    },
    mixins: [
        SampleOperationGuardMixin
    ],
    props: {
        initMode: {
            type: Object,
            default: () => ({ value: 'compact', icon: 'fal fa-list-ul' })
        },
        laboratoryId: { type: Number },
        caseId: { type: Number },
        sample: { type: Object, required: true },
        isCaseValidated: { type: Boolean }
    },
    data() {
        return {
            viewToggle: true,
            chevronEdit: true,
            chevronOrig: true,
            chevronVideo: true,
            mode: this.initMode,
            optionsmulti: [
                { value: 'compact', icon: 'fal fa-list-ul' },
                { value: 'normal', icon: 'fal fa-th-list' },
                { value: 'card', icon: 'fal fa-columns' }
            ],
            macroEditedAttachments: [],
            macroImageAttachments: [],
            macroVideoAttachments: [],
            mockAttachmentsChecked: 0,
            broadCastAttachmentUpdateChannel: null
        }
    },
    computed: {
        ATTACHMENT_ENTITY_TYPE() {
            return ATTACHMENT_ENTITY_TYPE.SAMPLE
        },
        entitiesIdArray() {
            return [this.laboratoryId, this.caseId, this.sample.id]
        },
        attachmentsChecked() {
            const editedAttachmentsChecked = this.macroEditedAttachments.filter(attachment => attachment.checked).length
            const macroImageAttachments = this.macroImageAttachments.filter(attachment => attachment.checked).length
            const macroVideoAttachments = this.macroVideoAttachments.filter(attachment => attachment.checked).length
            return editedAttachmentsChecked + macroImageAttachments + macroVideoAttachments + this.mockAttachmentsChecked
        }
    },
    watch: {
        sample(_newValue) {
            this.reloadImageAndVideoAttachments()
        }
    },
    created() {
        this.reloadImageAndVideoAttachments()
        this.broadCastAttachmentUpdateChannel = new BroadcastChannel(BROADCAST_ATTACHMENT_UPDATED_CHANNEL)
        this.broadCastAttachmentUpdateChannel.onmessage = () => {
            this.reloadImageAndVideoAttachments()
        }
    },
    beforeDestroy() {
        this.broadCastAttachmentUpdateChannel.close()
    },
    methods: {
        reloadImageAndVideoAttachments() {
            this.loadMacroImageAttachments()
            this.loadMacroVideoAttachments()
        },
        handleMockAttachmentChecked(mockAttachmentSelected) {
            if (mockAttachmentSelected) this.mockAttachmentsChecked++
            else this.mockAttachmentsChecked--
        },
        showPhotoModal() {
            this.$refs.modalPhotoWrapper.show()
        },
        async loadMacroImageAttachments() {
            let macroAttachments = await sampleAttachmentService.getAllMacroImageAttachments(
                this.laboratoryId,
                this.caseId,
                this.sample.id
            )

            this.macroImageAttachments = macroAttachments.filter(attachment => {
                return !attachment.hasAnnotations
            })

            this.macroEditedAttachments = macroAttachments.filter(attachment => {
                return attachment.hasAnnotations
            })
        },
        async loadMacroVideoAttachments() {
            this.macroVideoAttachments = await sampleAttachmentService.getAllMacroVideoAttachments(
                this.laboratoryId,
                this.caseId,
                this.sample.id
            )
        },
        showSampleAttachmentModal() {
            // TODO: Solo deberia seleccionar fotos y videos
            /* this.$refs.addFileModal.showConcreteAttachmentType('SAMPLE', 'attachment.type.macroscopicimage.code', (value) => {
            this.addSampleAttachment(value)
          }) */
            this.$refs.addFileModalWrapper.show()
        },
        async onAttachmentsAdded(attachments) {
            attachments.forEach(attachment => {
                if (attachment.mimetype.startsWith(ATTACHMENT_MIME_TYPES.IMAGE)) {
                    if (!this.macroImageAttachments) {
                        this.macroImageAttachments = []
                    }

                    this.macroImageAttachments.push(attachment)
                } else if (attachment.mimetype.startsWith(ATTACHMENT_MIME_TYPES.VIDEO)) {
                    if (!this.macroVideoAttachments) {
                        this.macroVideoAttachments = []
                    }

                    this.macroVideoAttachments.push(attachment)
                }
            })
            this.$emit('sample-attachment-added', this.sample.id)
        },
        deleteAttachmentConfirmation() {
            this.$refs.confirmationModal.ask(this.deleteAttachments)
        },
        async deleteAttachments() {
            const selectedIds = []
            if (this.$refs.grossingEditedThumbnail) {
                this.$refs.grossingEditedThumbnail.forEach((thumbnail) => {
                    if (thumbnail.isSelected) {
                        selectedIds.push(thumbnail.attachment.attachmentId)
                    }
                })
            }

            if (this.$refs.grossingThumbnail) {
                this.$refs.grossingThumbnail.forEach((thumbnail) => {
                    if (thumbnail.isSelected) {
                        selectedIds.push(thumbnail.attachment.attachmentId)
                    }
                })
            }

            if (this.$refs.grossingVideosThumbnail) {
                this.$refs.grossingVideosThumbnail.forEach((thumbnail) => {
                    if (thumbnail.isSelected) {
                        selectedIds.push(thumbnail.attachment.attachmentId)
                    }
                })
            }
            // TODO implement endpoint for deleting multiple attachments
            for (const attachmentId of selectedIds) {
                await sampleAttachmentService.deleteAttachment(
                    this.laboratoryId,
                    this.caseId,
                    this.sample.id,
                    attachmentId)
            }

            this.macroEditedAttachments = this.macroEditedAttachments.filter(attachment => !selectedIds.includes(attachment.attachmentId))
            this.macroImageAttachments = this.macroImageAttachments.filter(attachment => !selectedIds.includes(attachment.attachmentId))
            this.macroVideoAttachments = this.macroVideoAttachments.filter(attachment => !selectedIds.includes(attachment.attachmentId))
            this.$emit('sample-attachments-deleted')
        },
        openViewer(query) {
            if (query.atyDescription === 'attachment.type.macroscopicimage.description' ||
                query.atyDescription === 'attachment.type.microscopicimage.description' ||
                query.imageType !== 'OTHER') {
                viewerService.openViewer({
                    router: this.$router,
                    viewerType: ViewerType.STATIC_VIEWER,
                    laboratoryId: query.laboratoryId,
                    caseId: query.caseId,
                    sampleId: query.sampleId,
                    attachmentId: query.attachmentId,
                    label: query.label,
                    portionId: query.portionId,
                    subportionId: query.subportionId
                })
            } else {
                window.open(query.url, '_blank')
            }
        },
        hasBeenChanged() {
            return false
        },
        async save() {
            return true
        }
    }
}
</script>

<style lang="scss">
.grossingTabPhoto .ag-root-wrapper-body.ag-layout-normal {
  padding-left: 0;
  padding-right: 0;
}

.grossingTabPhoto .sr-panel-filters {
  padding-right: 1%;
}

.grossingTabPhoto .thumbs {
  overflow: hidden;
  overflow-y: auto;
}

.grossingTabPhoto .header-subtitle {
  text-transform: none !important;
}

.grossingTabPhoto .photo-collapse {
  background: none;
  padding: 0;
  border: none;
  font-size: 0.9rem;
}

.grossingTabPhoto .photo-collapse:focus {
  background: none !important;
  color: vt-color(dark-primary) !important;
}

.grossingTabPhoto .photo-collapse:hover {
  color: vt-color(dark-primary);
}
</style>

<style lang="scss" scoped>
.subtitle {
  font-size: font-size(very-tiny);
}

.photo-selector ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.photo-selector ul li {
  margin: 0 2% 1% 2%;
  font-size: 0.9rem;
}

.photo-selector ul li:hover {
  color: vt-color(primary);
  cursor: pointer;
}

.photo-selector-active {
  color: vt-color(primary);
}
</style>
